import { useEffect, useState } from "react";

import { gql } from "apollo-boost";
import moment from "../../Moment";

import ApolloClient from "../../services/apollo";

const GET_VACANCY = gql`
  query getVacancy(
    $date: Date!
    $currentDate: Date!
    $page: Int
    $limit: Int
    $arrival_location_id: Int
    $departure_location_id: Int
    $hour: String
    $minutes: String
  ) {
    getVacancies(
      date: $date
      currentDate: $currentDate
      page: $page
      limit: $limit
      departure_location_id: $departure_location_id
      arrival_location_id: $arrival_location_id
      hour: $hour
      minutes: $minutes
    ) {
      date
      hour
      minutes
    }
  }
`;
interface Variables {
  date: string;
  departure_location_id?: number | string;
  arrival_location_id?: number | string;
  pageNumber?: number;
  limit?: number;
  reload?: string;
}

const useVacancySearch = (name: string, variables: Variables) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [list, setList] = useState<any[]>([]);
  const [hasMore, setHasMore] = useState(true);

  const currentDate = moment().format("YYYY-MM-DD");

  useEffect(() => {
    setLoading(true);
    const {
      date,
      limit,
      arrival_location_id,
      departure_location_id,
      pageNumber,
    } = variables;
    const currentDay = moment();
    if (
      !error &&
      !(arrival_location_id === "0" || departure_location_id === "0")
    ) {
      ApolloClient.query({
        query: GET_VACANCY,
        variables: {
          date,
          currentDate,
          limit,
          departure_location_id,
          arrival_location_id,
          page: pageNumber,
          hour: currentDay.format("HH"),
          minutes: currentDay.format("mm"),
        },
        fetchPolicy: "no-cache",
      })
        .then((res) => {
          const data = res.data;
          setLoading(false);
          if (data[name].length !== limit && limit) {
            setHasMore(false);
          }
          if (data !== undefined) {
            return setList((prevList) => {
              if (limit && pageNumber) {
                return [...prevList, ...data[name]];
              }
              return data[name];
            });
          }
          return setError(true);
        })
        .catch((err) => {
          setLoading(false);
          setError(true);
          setHasMore(false);
        });
    } else {
      setLoading(false);
    }
  }, [
    variables.date,
    variables.arrival_location_id,
    variables.departure_location_id,
    variables.limit,
    variables.pageNumber,
    variables.reload,
  ]);

  return {
    loading,
    error,
    list,
    hasMore,
  };
};

export default useVacancySearch;
